import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useStore } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes';
import { initAuthSync } from './shared/authSessionSync';

function App() {
  const store = useStore();

  useEffect(() => {
    return initAuthSync(store);
  }, [store]);

  return (
    <Router>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router>
  );
}

export default App;